import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './MeetingStatisticsRadar.css';

// react-chartjs-2
//   React向けグラフ表示ライブラリ
//   ツールチップを常に表示する場合には、プラグインを作成する必要がある。
//   Webページ： https://github.com/jerairrest/react-chartjs-2
//   ライセンス情報： MIT Licensed Copyright (c) 2017 Jeremy Ayerst
import {Radar} from 'react-chartjs-2';
import Const from "../components/Const";

export default class MeetingStatisticsRadar extends Component {

  getMeetingStatisticsRadar() {
    let radars = [];
    let maxIndex = this.props.data.length;
    this.props.data.forEach((item, index)  => {
      radars.push(this.getRadar(item, index, maxIndex));
    });

    let empCount = maxIndex%3;
    if (empCount === 1) {
      radars.push(this.getEmpRadar(maxIndex));
      radars.push(this.getEmpRadar(maxIndex + 1));
    } else if (empCount === 2) {
      radars.push(this.getEmpRadar(maxIndex));
    }
    return radars;
  }
  
  getScore(score) {
    if (score < 25) {
      return 25;
    } else if (score > 75) {
      return 75;
    }

    return score;
  }

  getRadar(item, index, maxIndex) {
    let commentTotalScore = this.getScore(item.comment_total_score);
    let markCountScore = this.getScore(item.mark_count_score);
    let positiveCountScore = this.getScore(item.positive_count_score);
    let negativeCountScore = this.getScore(item.negative_count_score);
    let freeSettingCountScore = this.getScore(item.free_setting_count_score);
    let data = {
      labels: this.props.labels,
      datasets: [{
        borderColor: 'rgb(10, 80, 200)',
        backgroundColor: 'rgba(10, 80, 200, 0.4)',
        borderWidth: 1,
        pointRadius: 0,
        data: [commentTotalScore, markCountScore, positiveCountScore, negativeCountScore, freeSettingCountScore]
      }]
    };

    let className = "radar position-" + index%3;
    let line = Math.floor(index/3);
    let maxLine = Math.floor(maxIndex/3);
    if (line === 0) {
      className += " line-first";
    } else if (line === maxLine) {
      className += " line-last";
    } else {
      className += " line-mid";
    }
    let title_text = item.user_name;
    if ((item.authorization & Const.PERMISSION_CODE_GUEST) !== 0) {
      title_text = item.user_name + Const.GUEST_NAME_SUFFIX;
    }

      return (
      <div key={index} className={className}>
      <Radar
        data={data}
        width={220}
        height={220}
        options={{
          maintainAspectRatio: false,
          title: {
            display: true,
            fontSize: 16,
            fontColor: 'rgb(26, 46, 89)',
            text: title_text
          },
          legend: {
            display: false
          },
          scale: {
            display: true,
            pointLabels: {
              fontSize: 12,
              fontColor: 'rgb(26, 46, 89)'
            },
            ticks: {
              display: false,
              min: 25,
              max: 75,
              stepSize: 12.5,
            },
            gridLines: {
              display: true,
              color: 'rgb(226, 227, 232)'
            },
            angleLines: {
              display: false
            }
          }
        }}/>
      </div>
    );
  }

  getEmpRadar(index) {
    let className = "radar-emp position-" + index%3;
    let line = Math.floor(index/3);
    if (line === 0) {
      className += " line-first";
    } else {
      className += " line-last";
    }
    return (
      <div key={index} className={className} />
    );
  }

  render() {
    return (
      <div className="meeting-statistics-radar">
        <div className="inner-box">
          {this.getMeetingStatisticsRadar()}
        </div>
      </div>
   );
  }
}

MeetingStatisticsRadar.PropType = {
  data: PropTypes.object,
  labels: PropTypes.array
};
